import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { GetWorkTimeAccess } from '../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsApi';
import { DeleteItemsApi } from '../../../../../reduxToolkit/Commons/CommonsApi';
import {TABLES} from "../../../../../Apis/Tables";
import {EMPTY_VALUES, errorMsg} from "../../../../../Apis/functions";
import CustomTh from "../../../../../components/table/CustomTh";
import CustomTd from "../../../../../components/table/CustomTd";
import dayId from "../../../../../hooks/dayId";
import TableFunction from "../../../../../components/table/TableFunction";
import {permissionObj} from "../../../../../Helpers/permission";
import {
    DEFAULT_LEFT,
    LEFT_FIRST_COLUMN_WITH_CHECKBOX,
    SIMPLE_PAGINATION_MODEL
} from "../../../../../components/table/Model/TableModel";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const AccessFunctionality = ({id, modified, setModified}) => {
    const dispatch = useDispatch();
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const [selectedList, setSelectedList] = useState([]);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const tableId = 'tbl_af_employees_workshift_time';
    const searchId = 'txt_af_search_workshift_time';
    const [results, setResults] = useState({ content: [], totalElements: 0 });
    const deletePermission =   DEV || permission?.includes(permissionObj?.WEB_WORK_SHIFT_DELETE);
    const leftPosition = deletePermission ? LEFT_FIRST_COLUMN_WITH_CHECKBOX : DEFAULT_LEFT;

    // Function to generate the table header
    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={leftPosition} classes='first_head'>
                {t('zones').toUpperCase()}
            </CustomTh>,
            <CustomTh tableId={tableId}> {t('day').toUpperCase()}</CustomTh>,
            <CustomTh tableId={tableId}> {t('from').toUpperCase()}</CustomTh>,
            <CustomTh tableId={tableId}> {t('to').toUpperCase()}</CustomTh>,
        ];
    };
    // Function to generate the table body
    const getTbody = () => {
        if (!results || !results.content || results.content.length === 0)
            return {
                body: [],
                data: []
            };

        let body = results.content.map((item, index) => {
            return (
                <>
                    <CustomTd tableId={tableId} tooltip={item?.name} fixed={true} left={leftPosition} classes={'first-column'}>
                        {item?.zoneName || EMPTY_VALUES.DEFAULT}
                    </CustomTd>
                    <CustomTd tableId={tableId}>{dayId(item?.dayId)}</CustomTd>
                    <CustomTd tableId={tableId}> {item?.from || EMPTY_VALUES.DEFAULT}</CustomTd>
                    <CustomTd tableId={tableId}>{item?.to || EMPTY_VALUES.DEFAULT}</CustomTd>
                </>
            );
        });
        return {
            body: body,
            data: results.content,
        };
    };
    const getActionsButtons = () => {
        return <></>;
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        let contractPagination = SIMPLE_PAGINATION_MODEL.set({ page, rowsPerPage });
        if (id) {
            dispatch(GetWorkTimeAccess({ id, contractPagination })).then(({payload: {data: { data},},}) => {
                if(data){
                    setResults(data);
                }
            });
        }
    }

    const {
        t,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        rowsPerPage,
    } = TableFunction({
        fixedPagination: false,
        hasContainer: false,
        selectedList,
        setSelectedList,
        data: results,
        getThead,
        getTbody,
        labelRowsPerPage: 'access_per_page',
        setIsAllChecked,
        getData,//New
        modified,//New
        setModified,//New
    });

    //delete selected workshifts
    const deleteSelectedWorkShift = (deleteItem) => {
        dispatch(DeleteItemsApi({ tableName: TABLES.WORK_SHIFT_SCHEDULE, body: deleteItem }))
            .then(({payload: { data: { success, code }}}) => {
                if(success){
                    setSelectedList([]);
                    setIsAllChecked(false);
                    setModified(true);
                }else errorMsg(code);
        });
    };


    return {
        tableId,
        searchId,
        thead,
        tbody,
        isAllChecked,
        selectedList,
        setSelectedList,
        setIsAllChecked,
        showDeleteModal,
        setShowDeleteModal,
        pagination,
        getActionsButtons,
        handleCheckboxChange,
        handleDeleteAll,
        deleteSelectedWorkShift,
        deletePermission
    };
};

export default AccessFunctionality;
